import { getLocale } from "@recobra/i18n/runtime";

/** Orders options alphabetically by their label in the current locale, keeping `last` at the end. */
export const sortByLabel = <T>(
  options: readonly T[],
  label: (option: T) => string,
  last?: T,
): T[] => {
  const collator = new Intl.Collator(getLocale());

  return options.toSorted(
    (a, b) => Number(a === last) - Number(b === last) || collator.compare(label(a), label(b)),
  );
};
